import React, { useEffect, useState } from "react";
import StudentCertificateDetailComponent from "../../../components/studentCertificateDetail/StudentCertificateDetail";
import Notification from "../../../components/Notification/Notification";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCertificateByIdForStudentCertificate } from "../../../redux/features/studentDetailSlice";
import toast from "react-hot-toast";
import AdminNotification from "../../../components/Notification/AdminNotification";
import InstructorNotification from "../../../components/Notification/InstructorNotification";

const StudentCertificateDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [certificate, setCertificate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const auth = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("certificateId");
  const dispatch = useDispatch();

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchCertificateDetail = async () => {
      try {
        setLoading(true);
        setError(null);

        if (!id) {
          throw new Error("No certificate ID provided");
        }

        const res = await dispatch(
          getCertificateByIdForStudentCertificate({
            token: auth.token,
            certificateId: id,
          })
        ).unwrap();

        if (res?.data) {
          setCertificate(res.data);
        } else {
          setError("Certificate not found");
          toast.error("Certificate not found", {
            position: "top-center",
          });
        }
      } catch (err) {
        setError(
          err ||
          "Failed to fetch certificate details. Please try again."
        );
        toast.error(err || "Failed to fetch certificate details", {
          position: "top-center",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchCertificateDetail();
  }, [id, dispatch, auth.token, searchParams]);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="dottedLoading theme-color"></div>
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  if (!certificate) {
    return <div className="alert alert-info">Certificate not found</div>;
  }

  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3
            className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
            onClick={goBack}
          >
            <span className="icon-arrow-left"></span>Certificate Details
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            {auth.role.toLowerCase() === "student" ? <Notification /> : auth.role.toLowerCase() === "instructor" ? <InstructorNotification /> : auth.role.toLowerCase() === "admin" ? <AdminNotification /> : null}
          </div>
        </div>
      </div>
      <div>
        <StudentCertificateDetailComponent certificate={certificate} />
      </div>
    </>
  );
};

export default StudentCertificateDetail;
